module.exports = __webpack_public_path__ + "static/media/pig.ec354e0d.png";